import React from 'react'

export const SinglePageProfileIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="62"
    height="62"
    fill="none"
    viewBox="0 0 62 62"
  >
    <g filter="url(#filter0_d_867_684)">
      <circle cx="31" cy="27" r="21" fill="#fff" />
    </g>
    <path
      fill="#000"
      d="M42.205 26.745A12.517 12.517 0 0031 18.75a12.517 12.517 0 00-11.205 7.995.75.75 0 000 .51A12.517 12.517 0 0031 35.25a12.517 12.517 0 0011.205-7.995.75.75 0 000-.51zM31 33.75c-3.975 0-8.175-2.948-9.698-6.75 1.523-3.802 5.723-6.75 9.698-6.75 3.975 0 8.175 2.948 9.697 6.75-1.522 3.802-5.722 6.75-9.697 6.75z"
    />
    <path
      fill="#000"
      d="M31 22.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7.5a3 3 0 110-5.999A3 3 0 0131 30z"
    />
    <defs>
      <filter
        id="filter0_d_867_684"
        width="62"
        height="62"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_867_684" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_867_684"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
